import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EmployeeModel } from "../../entities/employee.model";

@Injectable()
export abstract class EmployeeRepositoryInterface {

    public abstract createEmployee(employee: EmployeeModel): Observable<EmployeeModel>;

    public abstract editEmployee(id: number, employee: EmployeeModel): Observable<EmployeeModel>;

    public abstract deleteEmployee(id: number);

}
